export default "__VITE_ASSET__ickC_kwY__"